import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQs = () => {
  const faqs = [
    {
      question: 'What types of insurance does Progress Insurance Solutions offer?',
      answer: "Progress Insurance Solutions offers a wide range of coverage solutions for both individuals and businesses. Our services include auto insurance, homeowners and renters insurance, flood insurance, umbrella coverage, and several commercial insurance options such as general liability, workers' compensation, commercial property, professional liability, and cyber coverage."
    },
    {
      question: 'What does it mean that Progress Insurance Solutions is an independent agency?',
      answer: 'As an independent insurance agency, Progress Insurance Solutions works with multiple top-rated insurance carriers rather than representing a single company. This allows us to compare policies, coverage options, and pricing to help you find the solution that best fits your needs and budget.'
    },
    {
      question: 'How do I know what type of coverage I need?',
      answer: 'Our advisors take the time to understand your situation, evaluate potential risks, and explain your options clearly. We help you choose coverage that provides the right level of protection without unnecessary complexity.'
    },
    {
      question: 'Can I get a free insurance quote?',
      answer: 'Yes. Progress Insurance Solutions offers free, no-obligation insurance quotes. Our team will review your needs and provide options from multiple carriers so you can make an informed decision.'
    },
    {
      question: 'How quickly can I receive a Certificate of Insurance?',
      answer: 'In most cases, Certificates of Insurance can be issued quickly once your policy is active. Our team understands that businesses often require certificates for contracts, vendors, or projects, and we work to provide them promptly.'
    },
    {
      question: 'Does homeowners insurance cover flood damage?',
      answer: 'Standard homeowners insurance policies typically do not cover flood damage. If you live in a flood-prone area or want additional protection, our team can help you secure dedicated flood insurance coverage.'
    },
    {
      question: 'What is umbrella insurance?',
      answer: 'Umbrella insurance provides an additional layer of liability protection that extends beyond the limits of your home or auto insurance policy. It helps protect your personal assets if a major claim exceeds the limits of your primary coverage.'
    },
    {
      question: 'How often should I review my insurance policies?',
      answer: 'It is a good idea to review your coverage annually or whenever you experience major life or business changes, such as purchasing property, expanding your business, or adding vehicles. Our team can help ensure your coverage keeps pace with your evolving needs.'
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-slate-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">Frequently Asked Questions</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Find answers to common questions about our insurance services and coverage options.
          </p>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-2 border-slate-200 rounded-lg px-6 hover:border-[#C9A361] transition-colors">
                <AccordionTrigger className="text-left text-lg font-semibold text-slate-900 hover:text-[#C9A361] py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Still Have Questions Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-slate-900 mb-6">Still Have Questions?</h2>
          <p className="text-xl text-slate-600 mb-8">
            Our team is ready to provide personalized answers and guidance. We're here to help you understand your insurance options.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-[#C9A361] hover:bg-[#B8925A] text-white px-8 py-6 text-lg transition-all hover:scale-105">
                Contact Us Today
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <a href="tel:954-495-2929">
              <Button size="lg" variant="outline" className="border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white px-8 py-6 text-lg transition-all">
                Call 954-495-2929
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQs;
